import React, { useState, useEffect } from "react";
import {
  Toolbar,
  IconButton,
  Typography,
  Box,
  InputBase,
  Badge,
  Avatar,
  Menu,
  MenuItem,
  Divider,
  ListItemIcon,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import PortraitOutlinedIcon from "@mui/icons-material/PortraitOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import LogoutIcon from "@mui/icons-material/Logout";
import {
  Close as CloseIcon,
  Menu as MenuIcon,
  Search as SearchIcon,
  NotificationsNone,
} from "@mui/icons-material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import headerLogo from "../../assets/images/headerLogo.svg";
import img from "../../assets/images/Image.png";
import { useAppSelector } from "../../globalState/hooks";
import { useDispatch } from "react-redux";
import { setDashboardSearchKey } from "../../globalState/actions/dashboard/dashboardAction";
import { setUserLogoutData } from "../../globalState/actions/authAction/authAction";
import { LoginRootState } from "../../types/login";
import loginService from "../../services/loginServices";
import GoogleAppsMenu from "../../components/googleApps";

interface HeaderProps {
  onMenuClick: () => void;
}

const HeaderSection: React.FC<HeaderProps> = ({ onMenuClick }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userDetails = useAppSelector(
    (state: LoginRootState) => state.authReducer.loginDetials
  );

  const dashboardSearchKey = useAppSelector(
    (state) => state.dashboardReducer.dashboardSearch
  );
  const excludedDesignations = ["Associate Engineer", "Intern"];
  const isExcludedDesignation = excludedDesignations.includes(
    userDetails?.designation
  );
  const [profileMenu, setProfileMenu] = useState<null | HTMLElement>(null);
  const [notification, setNotification] = useState<null | HTMLElement>(null);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [searchInput, setSearchInput] = useState("");
  const openProfile = Boolean(profileMenu);
  const open = Boolean(anchorEl);
  const [showMobileSearch, setShowMobileSearch] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    setSearchInput(dashboardSearchKey);
  }, [dashboardSearchKey]);

  const handleProfileMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setProfileMenu(event.currentTarget);
  };
  const handleNotificationClick = (event: React.MouseEvent<HTMLElement>) => {
    setNotification(event.currentTarget);
  };

  const handleClose = () => {
    setProfileMenu(null);
    setNotification(null);
    setAnchorEl(null);
  };

  const notifications = [
    {
      name: "Lex Murphy",
      time: "Today at 9:42 AM",
      image: img,

      content: "New message from HR",
    },
    {
      name: "Lex Murphy",
      time: "Today at 9:42 AM",
      image: img,

      content:
        "Your report is approved Your report is approved Your report is approved proved Your report is approved",
    },
    {
      name: "Lex Murphy",
      time: "Today at 9:42 AM",
      image: img,

      content: "System update available",
    },
    {
      name: "Lex Murphy",
      time: "Today at 9:42 AM",
      image: img,
      content: "Meeting scheduled at 3 PM",
    },
  ];

  //// search input onchange
  const handleSearchInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { value } = event.target;
    setSearchInput(value);
  };

  /// handle On Save Search Input data
  const handleSearchDashboardData = () => {
    dispatch(setDashboardSearchKey(searchInput));
  };

  //// handle clear search input
  const handlSearchInputClear = () => {
    setSearchInput("");
    dispatch(setDashboardSearchKey(""));
  };

  const handleLogout = async () => {
    try {
      const response = await loginService.logoutAPI();
      const logoutUrl = response?.data?.logoutUrl;

      if (logoutUrl) {
        localStorage.clear();
        dispatch(setUserLogoutData());
        window.location.href = logoutUrl;
      }
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };
  // handle mobile search
  if (showMobileSearch && isMobile) {
    return (
      <Box
        sx={{
          backgroundColor: "#0A0A0A",
          color: "#ffffff",
          px: 2,
          py: 1,
          display: "flex",
          alignItems: "center",
          height: "60px",
        }}
      >
        <SearchIcon
          sx={{
            color: "#B0B0B0",
            fontSize: 20,
            cursor: "pointer",
            mr: 1,
          }}
          onClick={() => handleSearchDashboardData()}
        />
        <InputBase
          autoFocus
          placeholder="Search contact..."
          sx={{
            color: "#fff",
            fontSize: "0.85rem",
            flex: 1,
            borderBottom: "1px solid #FFFFFF",
          }}
          value={searchInput}
          onChange={handleSearchInputChange}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleSearchDashboardData();
              setShowMobileSearch(false);
            }
          }}
        />
        <CloseIcon
          sx={{
            fontSize: 20,
            color: "#F3F3F3",
            cursor: "pointer",
          }}
          onClick={() => {
            setShowMobileSearch(false);
            handlSearchInputClear();
          }}
        />
      </Box>
    );
  }

  return (
    <>
      <Box
        position="static"
        sx={{
          backgroundColor: "#0A0A0A",
          color: "#ffffff",
          borderTop: "5px solid #DAAA00",
        }}
      >
        <div style={{ border: "1.5px solid #444B52" }}></div>
        <Toolbar sx={{ borderTop: "2px solid #DAAA00" }}>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={onMenuClick}
          >
            <MenuIcon />
          </IconButton>

          <Link to="/dashboard">
            <Typography
              component="span"
              sx={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                height: { md: "25px", sm: "25px", xs: "60px" },
              }}
            >
              <img
                className="mx-2"
                src={headerLogo}
                alt="Logo"
                style={{ height: "100%", width: "auto", cursor: "pointer" }}
              />
            </Typography>
          </Link>

          <Box
            className="header__Links"
            sx={{ display: { md: "flex", sm: "none", xs: "none" }, ml: 2 }}
          >
            <Link
              to="/dashboard"
              className={`commonLink f-14 ${
                location.pathname === "/dashboard" ? "active_link" : ""
              }`}
            >
              Home
            </Link>
            {!isExcludedDesignation && (
              <a
                href="https://performancemanager10.successfactors.com/sf/home?bplte_company=C0001163367P&_s.crb=2cnMDi%2bzdD40Me9%2fnga5p2fFNJ8%3d"
                target="_blank"
                rel="noopener noreferrer"
                className="commonLink"
              >
                RELink
              </a>
            )}
            {userDetails?.designation === "Associate Engineer" && (
              <a
                href="https://rehris.peoplestrong.com/secureSloginRedirect.jsf?idp=Okta&organizationId=383"
                target="_blank"
                rel="noopener noreferrer"
                className="commonLink"
              >
                RE Worklife(AE)
              </a>
            )}
            {(userDetails?.country === "India" ||
              userDetails?.isReworklifeManager) && (
              <>
                {!isExcludedDesignation && (
                  <a
                    href="https://re.peoplestrong.com/secureSloginRedirect.jsf?idp=RoyalEnfield"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="commonLink"
                  >
                    RE Worklife
                  </a>
                )}
              </>
            )}
            {userDetails?.employeeCategory === "Staff & Executives" && (
              <a
                href="https://learningmanagereu.adobe.com/12803"
                target="_blank"
                rel="noopener noreferrer"
                className="commonLink"
              >
                RE Accelerate
              </a>
            )}

            {(userDetails?.country === "India" || userDetails?.country === "Thailand") && (
              <>
                {!isExcludedDesignation && (
                  <a
                    href="https://royalenfield.okta.com/home/royalenfield_travelglobalexpense_1/0oaxaq2zb7ZoJDMdz2p7/alnxaqd9kvXiv1vay2p7"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="commonLink"
                  >
                    BRE Claim
                  </a>
                )}
              </>
            )}
            {userDetails?.country === "UK" && (
              <>
                {!isExcludedDesignation && (
                  <a
                    href="https://app.fcmtravel.com/login"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="commonLink"
                  >
                    FCM Travel Portal
                  </a>
                )}
              </>
            )}
            {/*  only show to User Authorized For EML */}
            {userDetails.isUserAuthorizedForEML && (
              <a
                href="https://dp-prod-dot-designated-person-form.el.r.appspot.com/dpform"
                target="_blank"
                rel="noopener noreferrer"
                className="commonLink"
              >
                EML Compliance
              </a>
            )}

            {/* <Button
              className="commonLink"
              onClick={handleClick}
              sx={{ color: "#000", textTransform: "none" }}
            >
              More +
            </Button> */}
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
              transformOrigin={{ vertical: "top", horizontal: "left" }}
              className="dropdown-menu"
              sx={{
                borderRadius: "0px",
                "& .MuiPaper-root": {
                  borderRadius: "0px",
                  backgroundColor: "#393939",
                  color: "#ffffff",
                },
                "& .MuiList-root": {
                  borderRadius: "0px",
                  padding: "0px",
                },
              }}
            >
              <MenuItem onClick={handleClose}>
                <Link to="/option1" className="dropdown-item">
                  Option 1
                </Link>
              </MenuItem>
              <MenuItem onClick={handleClose}>
                <Link to="/option2" className="dropdown-item">
                  Option 2
                </Link>
              </MenuItem>
              <MenuItem onClick={handleClose}>
                <Link to="/option3" className="dropdown-item">
                  Option 3
                </Link>
              </MenuItem>
            </Menu>
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", ml: "auto" }}>
            <Box
              sx={{
                position: "relative",
                borderBottom: { xs: "none", sm: "1px solid #808080" },
                width: { xs: "65px", sm: "200px" },
                height: "26px",
                display: "flex",
                alignItems: "center",
                ml: { xs: "0px", sm: "-8px" },
                mr: { xs: "0px", sm: 2 },
              }}
            >
              <SearchIcon
                sx={{
                  position: "absolute",
                  left: { xs: 0, sm: 8 },
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#B0B0B0",
                  fontSize: 18,
                  cursor: "pointer",
                }}
                onClick={() => {
                  if (isMobile) {
                    setShowMobileSearch(true);
                  } else {
                    handleSearchDashboardData();
                  }
                }}
              />
              <InputBase
                placeholder="Search contact..."
                sx={{
                  ml: 4,
                  color: "#fff",
                  fontSize: "0.85rem",
                  width: "100%",
                  display: { xs: "none", sm: "block" },
                }}
                value={searchInput}
                onChange={handleSearchInputChange}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSearchDashboardData();
                  }
                }}
              />
              <CloseIcon
                sx={{
                  fontSize: 12,
                  color: "#F3F3F3",
                  cursor: "pointer",
                  display: { xs: "none", sm: "block" },
                }}
                onClick={handlSearchInputClear}
              />
            </Box>
            <Box style={{ display: "none" }}>
              <Badge
                onClick={handleNotificationClick}
                badgeContent={12}
                color="error"
                sx={{
                  "& .MuiBadge-badge": {
                    top: "16px",
                    right: "9px",
                    minWidth: "10px",
                    height: "16px",
                    fontSize: "0.65rem",
                    borderRadius: "50%",
                    padding: "4px",
                  },
                }}
              >
                <IconButton color="inherit" sx={{ position: "relative", p: 1 }}>
                  <NotificationsNone sx={{ fontSize: 23, color: "#FFFFFF" }} />
                </IconButton>
              </Badge>
              <Menu
                anchorEl={notification}
                open={Boolean(notification)}
                onClose={handleClose}
                sx={{
                  mt: 1.5,
                  borderRadius: "8px",
                  boxShadow: "0px 2px 10px 5px rgba(0, 0, 0, 0.10)",
                  minWidth: 250,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    mb: 1,
                  }}
                >
                  <Typography
                    className=" f-16 f-bold"
                    sx={{
                      paddingX: 2,
                    }}
                  >
                    Notification
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      paddingX: 2,
                      color: "#808080",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      className=" f-12"
                      sx={{
                        fontWeight: 400,
                      }}
                    >
                      Mark all as read
                    </Typography>
                    <CheckCircleOutlineIcon
                      sx={{
                        fontSize: "14px",
                        color: "#808080",
                        paddingLeft: "5px",
                      }}
                    />
                  </Box>
                </Box>
                {notifications.length > 0 ? (
                  notifications.map((item, i) => (
                    <MenuItem
                      onClick={handleClose}
                      sx={{
                        marginTop: "5px",
                        marginBottom: "0px",
                        borderBottom: "1px solid #E4E8EE",
                        display: "flex",
                        alignItems: "flex-start",
                        gap: 2,
                        flexDirection: "row",
                      }}
                      key={i}
                    >
                      {/* Image Box */}
                      <Box
                        sx={{
                          width: 30,
                          height: 30,
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "flex-start",
                          justifyContent: "center",
                          verticalAlign: "top",
                          overflow: "hidden",
                          mt: "3px",
                        }}
                      >
                        <img
                          src={item.image}
                          alt="img"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: "50%",
                          }}
                        />
                      </Box>

                      {/* Content Box */}
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          flexGrow: 1,
                          maxWidth: "280px",
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{ wordWrap: "break-word", whiteSpace: "normal" }}
                        >
                          <Typography component="span" className="f-bold f-14">
                            {item.name}
                          </Typography>{" "}
                          {item.content}
                        </Typography>
                        <Typography
                          className="f-12"
                          sx={{
                            marginTop: "5px!important",
                            mb: "10px!important",
                            fontWeight: 700,
                            display: "block",
                            color: "#6c757d",
                          }}
                        >
                          {item.time}
                        </Typography>
                      </Box>
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem onClick={handleClose}>
                    <Typography variant="body2">No notifications</Typography>
                  </MenuItem>
                )}
              </Menu>
            </Box>

            {/* Google Apps dropdown */}
            <GoogleAppsMenu />

            <Box
              className="user-profile"
              sx={{
                borderRadius: "50%",
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                backgroundColor: "#ddd",
                marginLeft: "5px",
              }}
              onClick={handleProfileMenuClick}
            >
              <Avatar
                src={userDetails.photoUrl ? userDetails.photoUrl : img}
                alt="User Profile"
                sx={{
                  width: "100%",
                  height: "100%",
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
            </Box>
          </Box>
        </Toolbar>
      </Box>
      <Menu
        anchorEl={profileMenu}
        open={openProfile}
        onClose={handleClose}
        sx={{
          mt: 1.5,
          borderRadius: "8px",
          boxShadow: "0px 2px 10px 5px rgba(0, 0, 0, 0.10)",
          minWidth: 200,
        }}
      >
        <MenuItem onClick={handleClose}>
          <ListItemIcon>
            <PortraitOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <Typography variant="body2">Account Settings</Typography>
        </MenuItem>

        {/* My Settings */}
        <MenuItem onClick={handleClose}>
          <ListItemIcon>
            <SettingsOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <Typography variant="body2">My Setting</Typography>
        </MenuItem>

        {/* Admin Section */}
        {[
          "jeeve@royalenfield.com",
          "earnestkoilraj@royalenfield.com",
          "evinothraja@royalenfield.com",
          "sarathkumar@royalenfield.com",
          "vprem@royalenfield.com",
          "karthik.peddaraju@royalenfield.com",
          "rajalakshmib@royalenfield.com",
        ].includes(userDetails?.email) && (
          <MenuItem
            className={`${
              location.pathname === "/adminSection" ? " active_link" : ""
            }`}
            onClick={() => {
              handleClose();
              navigate("/adminSection");
            }}
          >
            <ListItemIcon>
              <ManageAccountsOutlinedIcon fontSize="small" />
            </ListItemIcon>
            <Typography variant="body2">Admin Section</Typography>
          </MenuItem>
        )}

        <Divider />

        {/* Logout Button */}
        <MenuItem onClick={handleLogout} sx={{ color: "red" }}>
          <ListItemIcon>
            <LogoutIcon fontSize="small" sx={{ color: "red" }} />
          </ListItemIcon>
          <Typography variant="body2" sx={{ fontWeight: "bold" }}>
            Log Out
          </Typography>
        </MenuItem>
      </Menu>

      {/* // Mobile Header// */}
      <Box
        className="header__Links"
        sx={{
          display: { xs: "flex", sm: "flex", md: "none" },
          justifyContent: "flex-start",
          padding: 0,
          background: "#0A0A0A",
          flexWrap: "nowrap",
          overflowX: "auto",
          overflowY: "hidden",
          whiteSpace: "nowrap",
          gap: 1,
          "& a": {
            flexShrink: 0,
          },
        }}
      >
        <Link
          to="/dashboard"
          className={`commonLink Mobile f-14 ${
            location.pathname === "/dashboard" ? "active_link" : ""
          }`}
        >
          Home
        </Link>
        {!isExcludedDesignation && (
          <a
            href="https://performancemanager10.successfactors.com/sf/home?bplte_company=C0001163367P&_s.crb=2cnMDi%2bzdD40Me9%2fnga5p2fFNJ8%3d"
            target="_blank"
            rel="noopener noreferrer"
            className="commonLink Mobile"
          >
            RELink
          </a>
        )}
        {userDetails?.designation === "Associate Engineer" && (
          <a
            href="https://rehris.peoplestrong.com/secureSloginRedirect.jsf?idp=Okta&organizationId=383"
            target="_blank"
            rel="noopener noreferrer"
            className="commonLink Mobile"
          >
            RE Worklife(AE)
          </a>
        )}
        {(userDetails?.country === "India" ||
          userDetails?.isReworklifeManager) && (
          <>
            {!isExcludedDesignation && (
              <a
                href="https://re.peoplestrong.com/secureSloginRedirect.jsf?idp=RoyalEnfield"
                target="_blank"
                rel="noopener noreferrer"
                className="commonLink Mobile"
              >
                RE Worklife
              </a>
            )}
          </>
        )}
        {userDetails?.employeeCategory === "Staff & Executives" && (
          <a
            href="https://learningmanagereu.adobe.com/12803"
            target="_blank"
            rel="noopener noreferrer"
            className="commonLink Mobile"
          >
            RE Accelerate
          </a>
        )}
        {(userDetails?.country === "India" || userDetails?.country === "Thailand") && (
          <>
            {!isExcludedDesignation && (
              <a
                href="https://royalenfield.okta.com/home/royalenfield_travelglobalexpense_1/0oaxaq2zb7ZoJDMdz2p7/alnxaqd9kvXiv1vay2p7"
                target="_blank"
                rel="noopener noreferrer"
                className="commonLink Mobile"
              >
                BRE Claim
              </a>
            )}
          </>
        )}
        {userDetails?.country === "UK" && (
          <>
            {!isExcludedDesignation && (
              <a
                href="https://app.fcmtravel.com/login"
                target="_blank"
                rel="noopener noreferrer"
                className="commonLink Mobile"
              >
                FCM Travel Portal
              </a>
            )}
          </>
        )}
        {/*  only show to User Authorized For EML */}
        {userDetails.isUserAuthorizedForEML && (
          <a
            href="https://dp-prod-dot-designated-person-form.el.r.appspot.com/dpform"
            target="_blank"
            rel="noopener noreferrer"
            className="commonLink Mobile"
          >
            EML Compliance
          </a>
        )}

        {/* <Button
              className="commonLink Mobile"
              onClick={handleClick}
              sx={{ color: "#000", textTransform: "none" }}
            >
              More +
            </Button> */}
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          className="dropdown-menu"
          sx={{
            borderRadius: "0px",
            "& .MuiPaper-root": {
              borderRadius: "0px",
              backgroundColor: "#393939",
              color: "#ffffff",
            },
            "& .MuiList-root": {
              borderRadius: "0px",
              padding: "0px",
            },
          }}
        >
          <MenuItem onClick={handleClose}>
            <Link to="/option1" className="dropdown-item">
              Option 1
            </Link>
          </MenuItem>
          <MenuItem onClick={handleClose}>
            <Link to="/option2" className="dropdown-item">
              Option 2
            </Link>
          </MenuItem>
          <MenuItem onClick={handleClose}>
            <Link to="/option3" className="dropdown-item">
              Option 3
            </Link>
          </MenuItem>
        </Menu>
      </Box>
    </>
  );
};

export default HeaderSection;
